/**
 * Shows a list read's refusal through the shared error modal once per
 * response, the same effect every list route in this app runs.
 */
import { useEffect } from "react";

import { extractErrorCode, showApiError } from "../../errors/apiErrorBus";

export function useShowListError(query: {
  data: unknown;
  dataUpdatedAt: number;
}): void {
  useEffect(() => {
    if (extractErrorCode(query.data) !== null) {
      showApiError(query.data, undefined, query.dataUpdatedAt);
    }
  }, [query.dataUpdatedAt]);
}
